import React from 'react'
import { HomeOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, message, Steps, Breadcrumb, Descriptions, PageHeader } from 'antd';
import { useState } from 'react';
//import BasicInfo from '../components/registration/BasicInfo';

import BasicregWithCollapse from '../../components/registration/BasicregWithCollapse';
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb';
import BasicInfo from '../../components/registration/BasicInfo';
import { Link } from 'react-router-dom';
import TapMembership from '../../components/tapcomponent/TapMebership';
import commonUtility from '../../utility/Utils';
import ClubAffiliationRegistrationView from '../../components/clubaffiliation/ClubAffiliationRegistrationView';



const ClubAffiliationRegistration = () => {

  return (
    <div className='inside-main-content'>

      <AdminBreadCrumb />





      <div className="box-style" >


        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Club Affiliation - Entry"
          subTitle=""
          extra={[
            // <Link to={`/tap/membershiplist`} key="reg_list">
            //   <Button key="1" shape='round' className='custom-button-white'> List</Button>
            // </Link>

           
          ]}
        >
        </PageHeader>

        <ClubAffiliationRegistrationView key={commonUtility.randomID()} />
        
    </div>







    </div>
  )
}

export default ClubAffiliationRegistration